import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "primeng/api";
import * as i2 from "./embedded-view/complex-dialog-embedded-view.service";
/**
 * @deprecated use complex dialog v3 component instead
 */
export class ComplexDialogV2Service {
  confirmationService;
  complexDialogV2EmbeddedViewService;
  constructor(confirmationService, complexDialogV2EmbeddedViewService) {
    this.confirmationService = confirmationService;
    this.complexDialogV2EmbeddedViewService = complexDialogV2EmbeddedViewService;
  }
  open(complexDialogV2Config, componentType, key) {
    const dialogKey = key ?? 'complex-dialog';
    this.complexDialogV2EmbeddedViewService.emitDialogData(complexDialogV2Config, dialogKey);
    this.confirmationService.confirm({
      key: dialogKey,
      message: ''
    });
    this.complexDialogV2EmbeddedViewService.emitComponentType(componentType, dialogKey);
  }
  close() {
    this.confirmationService.close();
  }
  emitDataOutputForComponent(data) {
    this.complexDialogV2EmbeddedViewService.emitDataOutputForComponent(data);
  }
  static ɵfac = function ComplexDialogV2Service_Factory(t) {
    return new (t || ComplexDialogV2Service)(i0.ɵɵinject(i1.ConfirmationService), i0.ɵɵinject(i2.ComplexDialogEmbeddedViewService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ComplexDialogV2Service,
    factory: ComplexDialogV2Service.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComplexDialogV2Service, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ConfirmationService
  }, {
    type: i2.ComplexDialogEmbeddedViewService
  }], null);
})();
